import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { HeaderHelperService } from '../header-helper.service';
import { UserListModel } from '../../models/user/user-list.model';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  constructor(
    private http: HttpClient,
    private headerHelperService: HeaderHelperService
  ) {}

  getUserList(page: number, size: number, filters: any = {}): Observable<any> {
    let url = `${
      environment.apiLocations.identity
    }/Users?PageRequest.PageIndex=${page - 1}&PageRequest.PageSize=${size}`;

    if (filters.nameSurname) {
      url += `&NameSurname=${filters.nameSurname}`;
    }

    if (filters.role) {
      url += `&RoleId=${filters.role}`;
    }

    if (filters.email) {
      url += `&Email=${filters.email}`;
    }

    if (filters.pid) {
      url += `&PID=${filters.pid}`;
    }

    if (filters.status) {
      url += `&UserStatus=${filters.status}`;
    }

    if (filters.startCreatedDate) {
      url += `&StartCreatedDateTime=${filters.startCreatedDate}`;
    }

    if (filters.endCreatedDate) {
      url += `&EndCreatedDateTime=${filters.endCreatedDate}`;
    }

    if (filters.startLastLoginDate) {
      url += `&StartLastLoginDate=${filters.startLastLoginDate}`;
    }

    if (filters.endLastLoginDate) {
      url += `&EndLastLoginDate=${filters.endLastLoginDate}`;
    }

    if (filters.organization) {
      url += `&Organization=${filters.organization}`;
    }

    return this.http.get<any>(url, {
      headers: this.headerHelperService.getHeaders(),
    });
  }

  getUser(id: string): Observable<any> {
    return this.http.get<UserListModel[]>(
      `${environment.apiLocations.identity}/Users/${id}`,
      {
        headers: this.headerHelperService.getHeaders(),
      }
    );
  }

  createUser(userData: any): Observable<UserListModel[]> {
    return this.http.post<UserListModel[]>(
      `${environment.apiLocations.identity}/Users`,
      userData,
      {
        headers: this.headerHelperService.getHeaders(),
      }
    );
  }

  editUser(id: string, userData: any): Observable<UserListModel[]> {
    return this.http.put<UserListModel[]>(
      `${environment.apiLocations.identity}/Users/${id}`,
      userData,
      {
        headers: this.headerHelperService.getHeaders(),
      }
    );
  }

  deleteUser(id: string): Observable<void> {
    return this.http.delete<void>(
      `${environment.apiLocations.identity}/Users/${id}`,
      {
        headers: this.headerHelperService.getHeaders(),
      }
    );
  }

  dermatologistList(): Observable<any> {
    return this.http.get<UserListModel[]>(
      `${environment.apiLocations.identity}/Users/GetDermatologistList`,
      {
        headers: this.headerHelperService.getHeaders(),
      }
    );
  }

  userDeviceId(): Observable<any> {
    return this.http.get<UserListModel[]>(
      `${environment.apiLocations.identity}/Users/GetUserDeviceId`,
      {
        headers: this.headerHelperService.getHeaders(),
      }
    );
  }

  blockUser(id: string): Observable<void> {
    return this.http.put<void>(
      `${environment.apiLocations.identity}/Users/BlockUser/${id}`,
      {},
      {
        headers: this.headerHelperService.getHeaders(),
      }
    );
  }

  activateUser(id: string): Observable<void> {
    return this.http.put<void>(
      `${environment.apiLocations.identity}/Users/ActivateUser/${id}`,
      {},
      {
        headers: this.headerHelperService.getHeaders(),
      }
    );
  }

  getExpertListByBackOffice(): Observable<any> {
    return this.http.get<UserListModel[]>(
      `${environment.apiLocations.identity}/Users/GetExpertListByBackOffice`,
      {
        headers: this.headerHelperService.getHeaders(),
      }
    );
  }
}
